import Vue from 'vue'


var estadoApp = new Vue({
    data: {
      usuario: null,
      token: null,
      admin:null,
      compartir:null,
      pagina:1,
      emailLogin:null,
      cargando:false,
    },
    methods: {
      cerrarSesion() {
        localStorage.removeItem( 'usuario' );
        localStorage.removeItem( 'token' );
        localStorage.removeItem( 'admin' );
        localStorage.removeItem( 'compartir' );
        localStorage.removeItem( 'pagina' );
        localStorage.removeItem( 'hash' );
        this.usuario = null;
        this.token = null;
        this.compartir = null;
        this.admin = null;
      },
      //Esta funcion se ejecuta cuando el usuario se loga correctamente
      establecerUsuario (usuario,token,admin,compartir) {
        this.usuario = usuario;
        this.admin = admin;
        this.token = token;
        this.compartir = compartir;
        localStorage.compartir = compartir;
        localStorage.token = token;
        localStorage.usuario = usuario;
        localStorage.emailLogin = usuario;
        localStorage.admin = admin;
      },
    },
    created () {
        this.compartir = localStorage.compartir;
        this.usuario = localStorage.usuario;
        this.token = localStorage.token;
        this.admin = localStorage.admin;
        this.emailLogin = localStorage.emailLogin;
    }
  })

export default estadoApp
